export default __webpack_public_path__ + "static/media/weather.2fc1b717.PNG";